import {IdNome} from '../id-nome.model';
import {Perfil} from './perfil.model';

export class PerfilRotina {
  perfil?: Perfil;
  rotina?: IdNome;

  constructor(perfil: Perfil, rotina: IdNome) {
    this.perfil = perfil;
    this.rotina = rotina;
  }
}
